import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'textLimiter'
})
export class TextLimiterPipe implements PipeTransform {

  transform(value: unknown, ...args: any[]): unknown {
    console.log(args[0]);
    if(args[0].length > 0) {
      let newArr = args[0].map((element, i) => {
        console.log(args[0].length - 1);
        if(element != null) {
          if(i < 2 && args[0].length > 1) {
            return element = element.name + ', ';
          } else if(i==(args[0].length - 1) && i >=2) {
            return element = '& '+(args[0].length-2)+'more'
          } else {
            return element.name
          }
        }
      });
      console.log(newArr);
      return newArr;
    } else {
      return args[0]
    }
  }

}
